//车辆成本统计管理
export default [{
  path: 'carCostAnalysisAdd',
  name: 'carCostAnalysisAdd',
  component: function component() {
    return import('@/views/carCostAnalysisManage/add');
  }
}, {
  path: 'carCostAnalysisList',
  name: 'carCostAnalysisList',
  component: function component() {
    return import('@/views/carCostAnalysisManage/list');
  }
}];